module.exports = __webpack_public_path__ + "img/NH.ffe5c13b.jpg";